import { useMemo } from "react";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `EntityIconRoot`
};

export function useEntityIconStyles(styleSet: IStyleSet) {
  return useMemo(
    () => mergeStyleSets(
      {
        root: [classNames.root, {}]
      },
      styleSet
    ),
    [styleSet]
  );
}
